import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal, RevealLines } from "../components/Reveal";
import { useI18n } from "../i18n";

export default function Network() {
  const { t } = useI18n();
  return (
    <>
      <PageHero label={t.network.label} title={t.network.heading} image="https://images.unsplash.com/photo-1431540015161-0bf868a2d407?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" alt="Executive network" />
      <section className="bg-[#062029] py-24 md:py-32 grain overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <Reveal>
            <p className="font-serif-display italic text-[#F7F5F0] text-3xl md:text-5xl leading-snug max-w-4xl">
              {t.network.body}
            </p>
          </Reveal>
          <div className="grid md:grid-cols-3 gap-10 mt-24">
            {t.network.stats.map((s, i) => (
              <Reveal key={i} delay={i * 0.12}>
                <div className="border-t border-[#F7F5F0]/15 pt-8">
                  <h3 className="font-serif-display text-[#C5A880] text-4xl md:text-5xl">{s.n}</h3>
                  <p className="font-body text-[#F7F5F0]/60 mt-3 tracking-wide">{s.l}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-[#F7F5F0] py-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 text-center">
          <RevealLines className="font-serif-display text-[#062029] text-3xl md:text-6xl leading-tight" lines={["These are people", "you want to speak with."]} />
          <Reveal delay={0.2}>
            <Link to="/contact" data-testid="network-cta" className="inline-flex items-center gap-3 mt-12 border border-[#062029]/40 text-[#062029] px-8 py-4 text-[12px] tracking-widest uppercase hover:bg-[#062029] hover:text-[#F7F5F0] transition-colors duration-500">
              {t.nav.cta} <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
